export default {
  SHOW_CONF_MODAL: 'SHOW_CONF_MODAL',
  DISMISS_CONF_MODAL: 'DISMISS_CONF_MODAL'
};
